export function calculateStakePerCombination(
    stake: number,
    numberOfCombinations: number) {
    return stake / (numberOfCombinations || 1);
}
